var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanrisul(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 154 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f0f0;}.cls-2{fill:#031026;}.cls-3{fill:#717786;}.cls-4{fill:#a1a3ab;}.cls-5{fill:#c3c7d4;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 154,
    height: 88,
    rx: 11
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    className: "cls-2",
    d: "M52.82,40.08A5.71,5.71,0,0,0,48.48,42V35.83a.43.43,0,0,0-.43-.43H46.78a.43.43,0,0,0-.43.43V51.9a.43.43,0,0,0,.43.43h1.27a.43.43,0,0,0,.43-.43V50.7a5.72,5.72,0,0,0,4.34,1.9,6,6,0,0,0,6.07-6.26,6,6,0,0,0-6.07-6.26m-.22,2.09a4.17,4.17,0,1,1-4.12,4.17,4.06,4.06,0,0,1,4.12-4.17"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    className: "cls-2",
    d: "M73.76,40.35H72.5a.43.43,0,0,0-.43.43V42a5.73,5.73,0,0,0-4.34-1.89,6,6,0,0,0-6.06,6.26,6,6,0,0,0,6.06,6.26,5.74,5.74,0,0,0,4.34-1.9v1.2a.43.43,0,0,0,.43.43h1.26a.43.43,0,0,0,.43-.43V40.78a.42.42,0,0,0-.43-.43M67.94,50.5a4.17,4.17,0,1,1,4.13-4.16,4,4,0,0,1-4.13,4.16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    className: "cls-2",
    d: "M84.37,40.08a5.35,5.35,0,0,0-3.87,1.47v-.77a.41.41,0,0,0-.43-.43H78.81a.43.43,0,0,0-.43.43V51.9a.43.43,0,0,0,.43.43h1.26a.43.43,0,0,0,.43-.43V45.57a3.23,3.23,0,0,1,3.5-3.4,3.13,3.13,0,0,1,3.32,3.36V51.9a.42.42,0,0,0,.43.43H89a.43.43,0,0,0,.43-.43V45.16a4.79,4.79,0,0,0-5.07-5.08"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    className: "cls-2",
    d: "M99.69,40.39h-.32A5,5,0,0,0,95.63,42V40.79a.43.43,0,0,0-.43-.43H93.94a.43.43,0,0,0-.43.43V51.91a.43.43,0,0,0,.43.43H95.2a.43.43,0,0,0,.43-.43V46.39a3.5,3.5,0,0,1,3.74-3.81h.32a.44.44,0,0,0,.43-.43V40.84a.42.42,0,0,0-.43-.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    className: "cls-2",
    d: "M104.77,40.35H103.5a.43.43,0,0,0-.43.43V51.9a.43.43,0,0,0,.43.43h1.27a.43.43,0,0,0,.43-.43V40.78a.41.41,0,0,0-.43-.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    className: "cls-2",
    d: "M104.14,35.91a1.35,1.35,0,1,0,1.37,1.33,1.34,1.34,0,0,0-1.37-1.33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    className: "cls-2",
    d: "M113.9,45.28c-1.68-.41-2.79-.74-2.79-1.74s1.18-1.43,2.34-1.43a3.81,3.81,0,0,1,2.84,1.19.42.42,0,0,0,.34.14.4.4,0,0,0,.32-.18l.71-.94a.42.42,0,0,0,0-.58,5.89,5.89,0,0,0-4.21-1.68c-2.65,0-4.49,1.47-4.49,3.56,0,2.56,2.36,3.16,4.28,3.66,1.66.4,2.73.74,2.73,1.72s-1.07,1.57-2.6,1.57A4.29,4.29,0,0,1,110,49.19a.43.43,0,0,0-.34-.15.42.42,0,0,0-.32.16l-.71.91a.45.45,0,0,0,0,.58,6.45,6.45,0,0,0,4.67,1.91c2.85,0,4.76-1.51,4.76-3.74,0-2.54-2.43-3.14-4.21-3.58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    className: "cls-2",
    d: "M131.6,40.35h-1.27a.43.43,0,0,0-.43.43v6.57a3.2,3.2,0,0,1-6.39,0V40.78a.42.42,0,0,0-.43-.43h-1.26a.43.43,0,0,0-.43.43v6.74c0,3,2.15,5.08,5.33,5.08s5.32-2,5.32-5.08V40.78a.44.44,0,0,0-.44-.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    className: "cls-2",
    d: "M137.8,35.39h-1.26a.43.43,0,0,0-.43.43V51.89a.43.43,0,0,0,.43.43h1.26a.43.43,0,0,0,.43-.43V35.83a.43.43,0,0,0-.43-.44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    className: "cls-3",
    d: "M35.4,38.34l-2.88-5a1.61,1.61,0,0,0-1.39-.81H25.36a1.59,1.59,0,0,0-1.39.81l-2.89,5a1.67,1.67,0,0,0,0,1.62L24,45a1.6,1.6,0,0,0,1.39.81h2.09l.79-1.38H25.36a.24.24,0,0,1-.21-.12l-2.88-5a.24.24,0,0,1,0-.23l2.88-5a.26.26,0,0,1,.21-.12h5.77a.22.22,0,0,1,.2.12l2.89,5a.24.24,0,0,1,0,.23l-1.68,2.93h1.59L35.42,40a1.62,1.62,0,0,0,0-1.62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    className: "cls-4",
    d: "M30.31,48,29,45.8H27.44l1.68,2.93a.24.24,0,0,1,0,.23l-2.89,5a.27.27,0,0,1-.2.12H20.25a.22.22,0,0,1-.2-.12l-2.89-5a.24.24,0,0,1,0-.23l2.89-5a.24.24,0,0,1,.2-.12h2.89l-.79-1.38H20.26a1.6,1.6,0,0,0-1.38.8L16,48a1.65,1.65,0,0,0,0,1.61l2.89,5a1.6,1.6,0,0,0,1.38.81H26a1.57,1.57,0,0,0,1.38-.81l2.89-5a1.53,1.53,0,0,0,0-1.61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    className: "cls-5",
    d: "M40.5,48l-2.89-5a1.6,1.6,0,0,0-1.39-.81H30.45a1.6,1.6,0,0,0-1.39.81L27.45,45.8H29l1.21-2.11a.24.24,0,0,1,.2-.12h5.77a.24.24,0,0,1,.21.12l2.88,5a.24.24,0,0,1,0,.23l-2.88,5a.28.28,0,0,1-.21.12H30.45a.22.22,0,0,1-.2-.12L29,51.9l-.8,1.38.82,1.41a1.61,1.61,0,0,0,1.39.81h5.77a1.59,1.59,0,0,0,1.39-.81l2.89-5a1.64,1.64,0,0,0,0-1.63"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanrisul);
export default __webpack_public_path__ + "static/media/banrisul.7e7f4924be81fbf9d94934a45679715f.svg";
export { ForwardRef as ReactComponent };